import React, { Fragment } from 'react';
import Header from './header/Header.js';
import Section from './sections/Section.js';
import Home from './sections/home/Home.js';
import About from './sections/about/About.js';
import Collections from './sections/collections/Collections.js';
import Testimonials from './sections/testimonials/Testimonials.js';
import ContactUs from './sections/contact-us/ContactUs.js';
import Footer from './footer/Footer.js';
import './App.scss';

function App() {
  return (
    <Fragment>
      <Header />
      <Section id='home'>
        <Home />
      </Section>
      <Section id='collections' background='dark'>
        <Collections />
      </Section>
      <Section id='about' background='dark'>
        <About />
      </Section>
      <Section id='testimonials' background='dark'>
        <Testimonials />
      </Section>
      <Section id='contact' background='dark'>
        <ContactUs />
      </Section>
      <Footer />
    </Fragment>
  );
}

export default App;